import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./blogSection.css";

export default function BlogSection() {
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  async function fetchPosts() {
    try {
      const res = await fetch("/api/posts");
      const data = await res.json();
      setPosts(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }



  if (loading) {
    return (
      <section className="blog-section">
        <h2>Loading...</h2>
      </section>
    );
  }

  return (
    <section className="blog-section">

     <button className="back-btn" onClick={() => navigate(-1)}>
  ← Back
</button>

      {posts.length === 0 ? (
        <div className="no-posts">
          <h2>No Available Posts</h2>
          <p>Come back later for new articles.</p>
        </div>
      ) : (
        posts.map((post) => (
          <article className="blog-card" key={post._id}>
            <div
              className="blog-image"
              style={{
                backgroundImage: `linear-gradient(rgba(31,27,24,.05), rgba(31,27,24,.25)), url(${post.image})`,
              }}
            />

            <div className="blog-content">
              <div className="blog-category">
                {post.author} • {post.date}
              </div>

              <h2>{post.title}</h2>

              <p>
                {Array.isArray(post.content)
                  ? post.content[0].substring(0, 180) + "..."
                  : ""}
              </p>

              <div className="blog-buttons">
                <button
                  className="blog-link"
                 onClick={() => navigate(`/blog/${post._id}`)}
                >
                  Read Post →
                </button>
              </div>
            </div>
          </article>
        ))
      )}
    </section>
  );
}
